import { OptionsType } from '../../types/selectTypes';
import { splitByCapitalLetters } from '../../utils/general.utils';

export const optionsTitle = {
  create: 'Question & Answer',
  update: 'Question & Answer',
  info: 'Question & Answer',
};

export interface IInfoObj {
  id: string,
  question: string,
  answer: string,
  link: string,
  title: string,
  category: OptionsType<number> | null,
  created: string,
  updated: string,
  updatedBy: string,
  createdBy: string,
}

export const defaultSelectedItem: IInfoObj = {
  id: '',
  question: '',
  answer: '',
  link: '',
  title: '',
  category: null,
  created: '',
  updated: '',
  updatedBy: '',
  createdBy: '',
};

export const prepareRowInfo = (data) => {
  const id = data?.id ?? '';
  const question = data?.question ?? '';
  const answer = data?.answer ?? '';
  const link = data?.metadata?.link ?? '';
  const title = data?.metadata?.title ?? '';
  const created = data?.created ?? '';
  const updated = data?.updated ?? '';
  const updatedBy = data?.updatedBy ?? '';
  const createdBy = data?.createdBy ?? '';

  const isReference = data?.referenceCategory && Object.keys(data?.referenceCategory);

  const category = {
    value: data?.referenceCategory,
    label: splitByCapitalLetters(String(data?.referenceCategory ?? '')),
  };

  return {
    id,
    question,
    answer,
    link,
    title,
    category: isReference ? category : null,
    created,
    updated,
    updatedBy,
    createdBy,
  };
};

export const prepareDataToCreateUpdate = (data) => {
  const answer = data?.answer ?? '';
  const question = data?.question ?? '';
  const link = data?.link ?? '';
  const title = data?.title ?? '';
  const metadata = (!!link && !!title) ? { link, title} : undefined;
  const referenceCategory = data?.category.value ?? null;
  return { answer, question, metadata, referenceCategory };
};

export enum ESuccessMessages {
  CREATE = 'Question & Answer has been created successfully',
  DELETE = 'Question & Answer has been deleted successfully',
  UPDATE = 'Question & Answer has been updated successfully',
}
